import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtRecordingDto, CourtRecordingStatus } from "../../../models/court-recording/dto/court-recording.dto";

export const GET_COURT_RECORDINGS_QUERY_KEY = (organizationId: string, status?: CourtRecordingStatus) =>
    ['court-recordings', 'list', organizationId, status];

export const useListCourtRecordings = (organizationId: string, status?: CourtRecordingStatus) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_COURT_RECORDINGS_QUERY_KEY(organizationId, status),
        queryFn: () => {
            let endpoint = `court-recordings/list?organizationId=${organizationId}`;
            if (status) {
                endpoint += `&status=${status}`;
            }
            return client.fetchApi<CourtRecordingDto[], {}>({
                endpoint,
                method: 'GET',
            });
        },
        staleTime: 10_000,
        enabled: Boolean(organizationId),
        refetchInterval: (data) => {
            const hasProcessing = data?.some(
                (r) => r.status === CourtRecordingStatus.QUEUED || r.status === CourtRecordingStatus.PROCESSING,
            );
            return hasProcessing ? 10_000 : false;
        },
    });
};
